var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinusXlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 3,
    viewBox: "0 0 17 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.413715 1.53223L16.9071 1.53223",
    stroke: "#FDFDFD",
    strokeWidth: 1.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusXlIcon);
export default __webpack_public_path__ + "static/media/MinusXLIcon.f876d24e830c63581869c1b77b0ba838.svg";
export { ForwardRef as ReactComponent };